module.exports = __webpack_public_path__ + "static/media/play.3728b007.mp3";